function Validator_checkbox(element) {
    this.$element = $(element);

    this.selectors = {
	    formParent: 'form[data-i4-decorator="Validator_form"]'
    };

    this.data = {
	    required: 'required',
	    messageFail: 'message-fail',
		validateOnSubmit: 'validate-on-submit'
    };

    this.triggers = {
	    validate: 'i4:validate',
	    updateView: 'i4:updateView',
	    refresh: 'i4:refresh'
    };

    this.classNames = {
	    failMessage: 'fail-message'
    };

    this.init = function() {

	    // console.log('init - checkbox');

	    this.$formParent = this.$element.parents(this.selectors.formParent);

	    this.dataRequired = this.$element.data(this.data.required);
	    this.dataMessageFail = this.$element.data(this.data.messageFail);

	    this.isGroup = this.$element.prop('tagName').toUpperCase() === 'UL';

		this.$formParent.trigger(this.triggers.refresh);

	    this.$element.on(this.triggers.validate, this.validate.bind(this));
		this.$element.on('keyup blur change', this.$elementChange.bind(this));

		this.prepareFailMessage();
		if (!(this.$formParent.length && this.$formParent.data(this.data.validateOnSubmit))) {
			this.validate();
		}
    };

    this.$elementChange = function() {
	    this.validate();
	    this.$element.trigger('i4:change');

	    this.$formParent.trigger(this.triggers.updateView);
    };

    this.validate = function() {
	    var isValid = false;
	    if (this.isGroup) {
		    isValid = this.$element.find(':checked').length > 0;
	    } else {
	    	isValid = this.$element.is(':checked');
	    }

	    this.$element.removeClass('invalid');
		this.$element.removeClass('valid');
		this.$failMessage.hide();

		if (isValid) {
			this.$element.addClass('valid');

		} else if (this.dataRequired) {
			this.$element.addClass('invalid');
			this.$failMessage.show();
		}
    };

    this.prepareFailMessage = function() {
	    this.$failMessage = $('<div></div>');

	    if (this.dataMessageFail !== undefined) {
		    this.$failMessage.
		    	addClass(this.classNames.failMessage).
		    	html(this.dataMessageFail).
		    	hide();

			var element = this.$element;

		    if (!this.isGroup) {
				element = this.$element.parent().parent();
			    if (element.next('label').length) {
					element = element.next();
			    } else {
					element = this.$element.parent();
				}
		    }

		    element.after(this.$failMessage);
	    }
    };

}
